/* eslint-disable camelcase */
function getNodeData (node) {
  // console.log(node)
  if (node?.type) { if (node.type === 'response_condition') return node }

  return node.data
}

module.exports.sortChildren = (children) => {
  if (children.length < 2) return children
  const sortedChildren = []
  const prevSiblingToCurrentNode = new Map()
  let currentNodeId = null

  children.forEach((child) => {
    const childData = getNodeData(child)
    if (!childData.previous_sibling) {
      currentNodeId = childData.dialog_node
      sortedChildren.push(child)
    } else {
      prevSiblingToCurrentNode.set(childData.previous_sibling, child)
    }
  })
  // console.log(JSON.stringify(sortedChildren))
  // console.log({ sortedChildren: sortedChildren.length, children: children.length })

  for (let index = 0; sortedChildren.length < children.length; index++) {
    const node = sortedChildren[index]
    // console.log(`node => ${node} sortedChildren count => ${sortedChildren.length} children[${index}] => ${JSON.stringify(children[index])}`)
    if (node) {
      let currentSortedChildrenData = getNodeData(node)
      currentNodeId = currentSortedChildrenData.dialog_node
      if (prevSiblingToCurrentNode.get(currentNodeId)) {
        const currentNode = prevSiblingToCurrentNode.get(currentNodeId)
        sortedChildren.push(currentNode)
        const currentNodeData = getNodeData(currentNode)
        currentNodeId = currentNodeData.dialog_node
      } else { break }
    }
  }

  return sortedChildren
}

function convertNodeFormat (node) {
  fixNodeOutput(node)
  return {
    $folded: true,
    data: {
      ...node,
      outputResponses: []
    },
    children: []
  }
}

function fixNodeOutput (node) {
  if (node?.output?.text) {
    node.output = {
      generic: [
        {
          ...node.output.text,
          values:
            node.output.text.values?.map((val) => ({
              text: val.text || val
            })) || [],
          response_type: 'text'
        }
      ]
    }
    delete node.output.text
  }
}

function createOutputResponseNode (node) {
  return {
    ...node,
    output: node.output.text
      ? {
        generic: [
          {
            ...node.output.text,
            values: node.output.text.values.map((val) => ({
              text: val
            })),
            response_type: 'text'
          }
        ]
      }
      : node.output
  }
}

function listToTree (list) {
  const map = new Map()
  const nodeMap = {}
  const dialogsTree = []
  const listCopy = []
  for (let i = 0; i < list.length; i += 1) {
    map.set(list[i].dialog_node, i)
    listCopy[i] =
      list[i].type === 'response_condition'
        ? createOutputResponseNode(list[i])
        : convertNodeFormat(list[i])
    nodeMap[list[i].dialog_node] = listCopy[i]
  }
  for (let i = 0; i < listCopy.length; i += 1) {
    const node = listCopy[i]
    const nodeData = getNodeData(node)
    if (nodeData.parent) {
      if (nodeData.type === 'response_condition') {
        listCopy[map.get(nodeData.parent)].data.outputResponses.push(node)
      } else if (nodeData.type === 'standard' || nodeData.type === 'folder') {
        listCopy[map.get(nodeData.parent)].children.push(node)
      } else {
        throw new Error('NEW NODE TYPE ????' + nodeData.type)
      }
    } else {
      dialogsTree.push(node)
    }
  }
  return [dialogsTree, nodeMap]
}

function hasResponseConditions (node) {
  return (
    node.data?.outputResponses?.length > 0 &&
    node?.data?.metadata?._customization?.mcr === true
  )
}

module.exports.sortEntireTree = (nodes) => {
  nodes.forEach((node) => {
    const allChildren = [...node.data.outputResponses, ...node.children]

    const sortedChildren = this.sortChildren(allChildren)

    const standardChildren = sortedChildren.filter(
      (node) => getNodeData(node).type === 'standard' || getNodeData(node).type === 'folder'
    )

    // Make sure that response condition nodes come first in the list of
    // children
    if (hasResponseConditions(node)) {
      const responseConditionsNodes = sortedChildren.filter(
        (node) => getNodeData(node).type === 'response_condition'
      )

      responseConditionsNodes.forEach((node, index, array) => {
        if (index === 0) {
          delete node.previous_sibling
        } else {
          const lastNode = array[index - 1]
          node.previous_sibling = lastNode.dialog_node
        }
      })

      node.data.outputResponses = responseConditionsNodes

      // response_condition nodes must always come first in the list of
      // children of a node, that's why the first standard child has as its
      // previous sibling the last of the response_condition nodes.
      const lastResponseConditionNode =
        responseConditionsNodes[responseConditionsNodes.length - 1]

      standardChildren.forEach((node, index, array) => {
        if (index === 0) {
          node.data.previous_sibling = lastResponseConditionNode.dialog_node
        } else {
          const lastNode = array[index - 1]
          node.data.previous_sibling = lastNode.data.dialog_node
        }
      })
    } else if (node.children[0]?.previous_sibling) {
      // Make sure that the first child doesn't have any previous siblings
      delete node.children[0].previous_sibling
      node.data.outputResponses = []
    }

    node.children = standardChildren

    if (node.children?.length) {
      this.sortEntireTree(node.children)
    }
  })
}

function propsFilter (object, props) {
  const newObject = {}
  props.forEach((prop) => {
    if (object[prop]) newObject[prop] = object[prop]
  })
  return newObject
}

module.exports.convertTreeNodeToDialogNode = function (node) {
  // TODO: Deal with digress
  return propsFilter(node, [
    'type',
    'title',
    'dialog_node',
    'description',
    'conditions',
    'parent',
    'previous_sibling',
    'output',
    'context',
    'metadata',
    'next_step',
    'event_name',
    'variable',
    'actions',
    // 'digress_in',
    'disabled',
    // 'digress_out',
    // 'digress_out_slots',
    'user_label',
    'disambiguation_opt_out'
  ])
}

module.exports.setPreviousSibling = (node, previousSibling, parent) => {
  if (previousSibling) {
    node.data.previous_sibling = previousSibling.data.dialog_node
  } else if (parent?.data?.metadata?._customization?.mcr) {
    const parentOutputResponses = parent.data.outputResponses
    const lastParentOutputResponse =
      parentOutputResponses[parentOutputResponses.length - 1]
    node.data.previous_sibling = lastParentOutputResponse.dialog_node
  } else {
    delete node.data.previous_sibling
  }
}

module.exports.convertTreeToList = (tree = [], parent = {}) => {
  if (!tree) return []
  const list = []
  tree.forEach((node) => {
    const children = node.children ? [...node.children] : []
    const nodeData = this.convertTreeNodeToDialogNode(node.data || {})
    list.push(nodeData)
    list.push(...this.convertTreeToList(children, node))

    const outputResponses = [...node.data?.outputResponses]
    const formatedResponses = outputResponses.map(
      this.convertTreeNodeToDialogNode
    )
    list.push(...formatedResponses)
  })
  return list
}

module.exports.sortTree = (dialogsTree) => {
  const sortedRoots = this.sortChildren(dialogsTree)
  this.sortEntireTree(sortedRoots)
  return sortedRoots
}

module.exports.convertListToTree = (dialogs) => {
  if (!dialogs) return
  const [dialogsTree, nodeMap] = listToTree(dialogs)
  const dialogsTreeSorted = this.sortTree(dialogsTree)
  return { tree: dialogsTreeSorted, nodeMap }
}
